import React from 'react';
import styled from "styled-components";

export const DownloadLinkStyled = styled.a`
font-weight: normal;
font-size: 14px;
margin: 10px;
color: rgb(235, 92, 28);
text-decoration: none;
`;